import { render, staticRenderFns } from "./PageNewFixedPriceTicket.vue?vue&type=template&id=22627258&scoped=true&"
import script from "./PageNewFixedPriceTicket.vue?vue&type=script&lang=js&"
export * from "./PageNewFixedPriceTicket.vue?vue&type=script&lang=js&"
import style0 from "./PageNewFixedPriceTicket.vue?vue&type=style&index=0&id=22627258&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22627258",
  null
  
)

export default component.exports